import { AppAction } from 'actions/types/ActionTypes'
import { generateLuxPlusSubscriptionItems } from 'lib/checkout/luxPlusSubscription/cart'
import { fireEcommerceGTMEvent } from 'api/googleTagManager'
import { addToCartGTM } from 'analytics/eventDefinitions'
import { addToCheckoutCart } from 'actions/CheckoutActions'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import { getCanRedeemLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'

interface PurchaseLuxPlus {
  hasJoinFee: boolean
  replaceCurrentWith?: string
}

function purchaseLuxPlus({ hasJoinFee, replaceCurrentWith }: PurchaseLuxPlus): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const currency = state.geo.currentCurrency
    const subscriptionProduct = state.luxPlus.products.subscription
    const isLuxPlusMember = getCanRedeemLuxPlusBenefits(state)

    if (
      !subscriptionProduct.offers ||
      isLuxPlusMember
    ) {
      return
    }

    const offer = subscriptionProduct.offers.find(offer => hasJoinFee ? !offer.joinFeeWaived : offer.joinFeeWaived)

    if (!offer) return

    const cartItems = generateLuxPlusSubscriptionItems(offer)
    fireEcommerceGTMEvent(addToCartGTM(offer, currency, offer.price + offer.joinFee, undefined, 'subscription'))

    dispatch(addToCheckoutCart(cartItems))
    dispatch(navigateToCheckout({ replaceCurrentWith }))
  }
}

export default purchaseLuxPlus
